<div class="container-app section-lg">
  <div class="text-center">
    <h1 class="text-6xl font-bold text-blue-600 mb-4">{{ title }}</h1>
    <p class="text-xl text-gray-600 mb-8">Create and share lists with ease</p>
    
    <div class="flex justify-center gap-4">
      <a routerLink="/sign-in" class="btn btn-primary">
        Get Started
      </a>
      <a *ngIf="isAuthenticated" routerLink="/lists" class="btn btn-outline">
        View Lists
      </a>
    </div>
  </div>
</div> 